import React, { useEffect, useState, useRef } from "react";
import classes from "./PurchaseOrder.module.css";
import HeaderNav from "../../../Components/Dahboard Header/HeaderNav/HeaderNav";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import searchicon from "../../../Assets/searchicon.png";
import filter from "../../../Assets/filter.png";
import Footer from "../../../Components/Footer/Footer";
import { Pen, Trash2, Printer } from "lucide-react";
import api from "../../../Components/API/Api";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";


const PurchaseOrder = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [invoices, setInvoices] = useState([]);
  const [loading, setLoading] = useState(true);
  const printRef = useRef();
  const pageMap = {
    "/dashboard": "Dashboard",
    "/transactions": "Transactions",
    "/accounts": "Accounting",
    "/reports": "Reports",
    "/banking": "Banking",
    "/settings": "Settings",
  };





  useEffect(() => {
    const fetchInvoices = async () => {
      try {
        const res = await api.get('/v1/fetch-purchases-invoice');
        if (res.data && res.data.status && Array.isArray(res.data.data)) {
          setInvoices(res.data.data);
        }
      } catch (err) {
        setInvoices([]);
      } finally {
        setLoading(false);
      }
    };
    fetchInvoices();
  }, []);

  const statusClass = (status) => {
    if (status === "Success") return classes.greenStatus;
    if (status === "Pending") return classes.yellowStatus;
    return classes.redStatus;
  };


  const handlePrint = (rowData) => {
    navigate("/invoice-previeww", {
      state: { invoice: rowData },
    });
  };

  const getDeliveryStatus = (item) => {
    if (item.is_supplied == 1) return { text: "Delivered", class: classes.greenStatus };
    if (item.is_supplied == 0) return { text: "Pending", class: classes.yellowStatus };

    if (item.status == "0") return { text: "Pending", class: classes.yellowStatus };
    if (item.status == "1") return { text: "Delivered", class: classes.greenStatus };
    if (item.status == "2") return { text: "Overdue", class: classes.redStatus };

    // ✅ Always return a fallback
    return { text: "Pending", class: classes.yellowStatus };
  };

  const getPaymentStatus = (item) => {
    const paid = Number(item.paid || 0);
    const amount = Number(item.amount || 0);
    const balance = Number(item.balance || 0);

    if (balance > 0) return { text: "Pending", class: classes.yellowStatus };
    if (balance == 0) return { text: "Paid", class: classes.greenStatus };
    if (paid == amount) return { text: "Paid", class: classes.greenStatus };

    // ✅ Always return a fallback
    return { text: "Pending", class: classes.yellowStatus };
  };



  return (
    <div>
      <HeaderNav activePage={pageMap[location.pathname]} />

      <div className={classes.Container}>
        <div className={classes.actionsbtn}>
          <button className={classes.btns} onClick={() => navigate("/transactions/sales-invoice/sales")}>Sales Invoice</button>
          <button className={classes.btns} onClick={() => navigate("/inventory/stocks_delivery")}>Stock Delivary</button>
          <button
            className={`${classes.btns} ${location.pathname === "/inventory/purchaseOrder" ? classes.active : ""
              }`}
            onClick={() => navigate("/inventory/purchaseOrder")}
          >
            Purchase Order
          </button>           {/* <button className={classes.btns}>All Invoices</button> */}
          <button className={`${classes.btns} ${classes.greens}`} onClick={() => navigate("/settings/product-services")}>Product & Services</button>
        </div>

        <header className={classes.Header}>
          <h2 className={classes.Title}>Purchases Order</h2>
          <h1 className={classes.Titles}>
            Add, View, Edit and Delete Purchase Order.
          </h1>
        </header>

        <div className={classes.entrjj}>
          <div className={classes.allkads}>
            <div className={classes.thrdkad}>
              <div className={classes.kad}>
                <p className={classes.kdptg}>Total Purchase</p>
                <p className={classes.kdptg1}>₦8,400,000.00</p>
                <div className={classes.rvnue}>
                  <p className={classes.skaltxt}>This month</p>
                </div>
              </div>
            </div>
            <div className={classes.frtkad}>
              <div className={classes.kad}>
                <p className={classes.kdptg}>Outstanding</p>
                <p className={classes.kdptg2}>₦4,950,000.00</p>
                <div className={classes.rvnue}>
                  <p className={classes.skaltxt}>Pending payments</p>
                </div>
              </div>
            </div>
            <div className={classes.fiftkad}>
              <div className={classes.kad}>
                <p className={classes.kdptg}>Overdue</p>
                <p className={classes.kdptg3}>₦3,200,000.00</p>
                <div className={classes.rvnue}>
                  <p className={classes.skaltxt}>Past due dates</p>
                </div>
              </div>
            </div>
            <div className={classes.frstkad}>
              <div className={classes.kad}>
                <p className={classes.kdptg}>This month</p>
                <p className={classes.kdptg4}>15</p>
                <div className={classes.rvnue}>
                  <p className={classes.skaltxt}>Total invoices</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className={classes.headerActions}>
          <div className={classes.actionsRight}>
            <div className={classes.inputWrapper}>
              <img src={searchicon} alt="Search" className={classes.inputIconGreen} />
              <input type="text" className={classes.searchBar} placeholder="Search sales" />
            </div>
            <div className={classes.selectWrapper}>
              <select className={classes.dropdown}>
                <option value="">All Status</option>
                <option value="Paid">Paid</option>
                <option value="Pending">Pending</option>
                <option value="Overdue">Overdue</option>
                <option value="Draft">Draft</option>
              </select>
              <span className={classes.dropdownArrow}>▼</span>
            </div>

            <div className={classes.inputWrapper}>
              <input type="text" className={classes.searchBars} placeholder="Filter..." />
              <img src={filter} alt="Filter" className={classes.inputIcon} />
            </div>
          </div>
          <button className={classes.btnss} onClick={() => navigate("/inventory/prchasing")}>Create Purchase Order</button>
        </div>

        <div className={classes.invoicecont}>
          <table className={classes.invoiceTable}>
            <table className={classes.invoiceTable}>
              <thead style={{ whiteSpace: "nowrap" }}>
                <tr>
                  <th>S/N</th>
                  <th>Invoice Number</th>
                  {/* <th>Description</th> */}
                  <th>Supplier Name</th>
                  <th>Transaction Date</th>
                  <th>Delivery Status</th>
                  <th>Payment Status</th>
                  <th>Amount</th>
                  <th>Post Date</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {loading
                  ? Array(5)
                    .fill()
                    .map((_, idx) => (
                      <tr key={idx}>
                        {Array(9) // 9 columns now (not 10 anymore)
                          .fill()
                          .map((_, i) => (
                            <td key={i}>
                              <Skeleton height={20} style={{ marginBottom: 10 }} />
                            </td>
                          ))}
                      </tr>
                    ))
                  : invoices.length === 0 ? (
                    <tr>
                      <td colSpan={9} style={{ textAlign: "center" }}>
                        No purchase invoices found.
                      </td>
                    </tr>
                  ) : (
                    invoices.map((item, index) => (
                      <tr key={item.id}>
                        <td>{index + 1}</td>
                        <td>{item.invoice_number || item.document_number || item.uuid}</td>
                        {/* <td>{item.description}</td> */}
                        <td>{item.supplier?.name || ""}</td>
                        <td>{item.transaction_date}</td>

                        {/* Delivery Status */}
                        <td className={getDeliveryStatus(item).class}>
                          {getDeliveryStatus(item).text}
                        </td>

                        {/* Payment Status */}
                        <td className={getPaymentStatus(item).class}>
                          {getPaymentStatus(item).text}
                        </td>

                        {/* Amount */}
                        <td style={{ textAlign: 'right' }}>{Number(item.amount).toLocaleString()}</td>

                        {/* Post Date */}
                        <td>{item.created_at ? item.created_at.split("T")[0] : ""}</td>

                        {/* Actions */}
                        <td className={classes.actions}>
                          <Pen size={16} className={classes.editIcon} />
                          <Trash2 size={16} className={classes.deleteIcon} />
                          <Printer
                            size={16}
                            className={classes.printIcon}
                            onClick={() => handlePrint(item)}
                            style={{ cursor: "pointer" }}
                          />
                        </td>
                      </tr>
                    ))
                  )}
              </tbody>

            </table>


          </table>

          <div className={classes.paginationContainer}>
            <div className={classes.paginationControls}>
              <button>First</button>
              <button className={classes.active}>1</button>
              <button>Last</button>
              <span className={classes.pageText}>Displaying 1 - 41 of 41</span>
            </div>
          </div>


        </div>
      </div>
      <Footer />
    </div>
  );
};

export default PurchaseOrder;
